import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { getConstants } from '../../constants/constants';
import { CookieService } from 'ngx-cookie-service';
import { Environment } from 'apps/web/dn-ms-website/src/environments/environment.interface';
import { APP_CONFIG } from '../../tokens/app-config.token';

@Injectable({
  providedIn: 'root',
})
export class TokenExtractorService {
  constructor(
    private readonly _cookieService: CookieService,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {}

  getCookieToken(): Observable<any> {
    const token = this._cookieService.get(getConstants(this.appConfig).COOKIE_TOKEN);
    return of(token);
  }

  getCookieDeviceId(): Observable<any> {
    const deviceId = this._cookieService.get(getConstants(this.appConfig).COOKIE_DEVICE_ID);
    return of(deviceId);
  }

  getCookieVerificationId() {
    return this._cookieService.get(getConstants(this.appConfig).COOKIE_VERIFICATION_ID);
  }
}
